import type { ISerialize } from '@/objects/ISerialize';

export class EngineDetails implements ISerialize {
    public Address: string | null;

    public Filters: string | null;

    public HasLocalCache: boolean;

    public HasSignalRDispatch: boolean;

    public IsOnline: boolean;

    public Name: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Address?: string | null;
        Filters?: string | null;
        HasLocalCache?: boolean;
        HasSignalRDispatch?: boolean;
        IsOnline?: boolean;
        Name?: string | null;
    }) {
        this.Address = values.Address ?? '';

        this.Filters = values.Filters ?? '';

        this.HasLocalCache = values.HasLocalCache ?? false;

        this.HasSignalRDispatch = values.HasSignalRDispatch ?? false;

        this.IsOnline = values.IsOnline ?? false;

        this.Name = values.Name ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"Address": ${JSON.stringify(this.Address)}` +
            ',' +
            `"Filters": ${JSON.stringify(this.Filters)}` +
            ',' +
            `"HasLocalCache": ${JSON.stringify(this.HasLocalCache)}` +
            ',' +
            `"HasSignalRDispatch": ${JSON.stringify(this.HasSignalRDispatch)}` +
            ',' +
            `"IsOnline": ${JSON.stringify(this.IsOnline)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            '}'
        );
    }

    /**
     * Creates an instance of EngineDetails from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Address?: string | null;
        Filters?: string | null;
        HasLocalCache?: boolean;
        HasSignalRDispatch?: boolean;
        IsOnline?: boolean;
        Name?: string | null;
    }): EngineDetails {
        return new EngineDetails(values);
    }

    public static _FromServerJson(json: any): EngineDetails {
        return new EngineDetails({
            Address: json.Address ?? '',
            Filters: json.Filters ?? '',
            HasLocalCache: json.HasLocalCache,
            HasSignalRDispatch: json.HasSignalRDispatch,
            IsOnline: json.IsOnline,
            Name: json.Name ?? '',
        });
    }

    /**
     * Creates an instance of EngineDetails from another instance of EngineDetails.
     * @param other The EngineDetails you want to clone
     * @returns A cloned EngineDetails
     */
    public static FromOther(other: EngineDetails): EngineDetails {
        return EngineDetails._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return EngineDetails.FromOther(this);
    }

    static NAME_OF_CLASS = 'EngineDetails';
}
